module.exports = __webpack_public_path__ + "img/c2-1_m.96683386.png";